import Vue from 'vue';
import Vuex from 'vuex';
import user from 'core/store/modules/user';
import flightSearchParams from './modules/flightSearchParams';
import { UserState } from 'core/store/modules/user';
import { FlightSearchParamsState } from './modules/flightSearchParams';

export interface RootState {
    user: UserState;
    flightSearchParams: FlightSearchParamsState;
}

Vue.use(<any>Vuex);

export default new Vuex.Store({
    modules: {
        user,
        flightSearchParams
    },
    strict: true
});
